<ng-container [formGroup]="batchFrom">
  <div class="mb-3 pb-2">
    <div class="input-label mb-2">Batch reports</div>

    <div>
      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="batch277ca"
      >
        277ca
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="batch277u"
      >
        277u
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="batchCSV"
      >
        Pulse CSV
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="batchHumanReadable"
      >
        Human Readable
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="batchMachineReadable"
      >
        Machine Readable
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="batchXml"
      >
        XML
      </checkbox>

      <checkbox
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="inputGenerates999"
      >
        Generate 999
      </checkbox>
    </div>
  </div>

  <div class="mb-3 pb-2">
    <div class="input-label mb-2">remittance</div>

    <div>
      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remit277ca"
      >
        277ca
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remit277u"
      >
        277u
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remitCsv"
      >
        CSV
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remitEraSummary"
      >
        ERA Summary
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remitHumanReadable"
      >
        Human Readable
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remitMachineReadable"
      >
        Machine Readable
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remitXml"
      >
        XML
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="remitCSVDaily"
      >
        Daily Pulse CSV
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="humanReadable271"
      >
        Human Readable 271
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="rejectPrintClaims"
      >
        Reject Print Claims
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="alphaII"
      >
        Alphall
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="newStatements"
      >
        New Statements
      </checkbox>

      <checkbox
        class="d-block mb-2"
        checkedValue="Y"
        uncheckedValue="N"
        formControlName="combineERA"
      >
        Combine ERA
      </checkbox>
    </div>
  </div>
</ng-container>
